import ProductSearchReducer from "./ProductSearchReducer";
import MerchantProductSearchReducer from "src/reducers/MerchantProductSearchReducer";
import GeneralProductSearchReducer from "src/reducers/GeneralProductSearchReducer";
import ProgramMetadataReducer from "src/reducers/ProgramMetadataReducer";
import WeblabReducer from "./WeblabReducer";
import SelectedProductReducer from "src/reducers/SelectedProductReducer";
import QueryProductReducer from "src/reducers/QueryProductReducer";
import ProgramFeesQueryReducer from "src/reducers/ProgramFeesQueryReducer";
import CurrentCountryCodeQueryReducer from "src/reducers/CurrentCountryCodeQueryReducer";
import IsSelectNewReducer from "src/reducers/IsSelectNewReducer";
import UserPreferenceReducer from "src/reducers/UserPreferenceReducer";
import RecommendationReducer from "src/reducers/RecommendationReducer";
import BulkProductReducer from "src/reducers/BulkProductReducer";
import BulkProductSearchReducer from "src/reducers/BulkProductSearchReducer";
import BulkReportQueryReducer from "src/reducers/BulkReportQueryReducer";
import FeeCatReducer from "src/reducers/FeeCatReducer";
import UserInputReducer from "src/reducers/UserInputReducer";
import BannerContentReducer from "src/reducers/BannerContentReducer";
import {CurrentCostReducer, CostPreferenceReducer, RemoveCostReducer} from "@amzn/seller-provided-costs-component";

function createReducer() {
    let reducers = {
        feeCatRes: FeeCatReducer,
        productRes: ProductSearchReducer,
        merchantProductRes: MerchantProductSearchReducer,
        generalProductRes: GeneralProductSearchReducer,
        programMetadataRes: ProgramMetadataReducer,
        recommendationRes: RecommendationReducer,
        programFeesRes: ProgramFeesQueryReducer,
        selectedProductRes: SelectedProductReducer,
        queryProductRes: QueryProductReducer,
        weblabTreatmentsRes: WeblabReducer,
        currentCountryCodeRes: CurrentCountryCodeQueryReducer,
        userPreferenceRes: UserPreferenceReducer,
        userInputRes: UserInputReducer,
        isSelectNewRes: IsSelectNewReducer,
        bulkProductsRes: BulkProductReducer,
        bulkProductSearchRes: BulkProductSearchReducer,
        bulkReportRes: BulkReportQueryReducer,
        bannerContentRes: BannerContentReducer,
        currentCostRes: CurrentCostReducer,
        costPreferenceRes: CostPreferenceReducer,
        removeCostsRes: RemoveCostReducer,
    };

    return reducers;
}

export default createReducer();
